<template>
  <b-row>
    <b-col sm="12" lg="12">
      <b-card class="lineClass">
        <div
          slot="header"
          style="display:flex; justify-content: space-between; align-items: center;"
        >
          <HeaderTitle title="Region Overview"></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            @emit-fullscreen="toggleFullScreenLine"
          ></HeaderControl>
        </div>
        <br />
        <GChart
          v-if="!loadingState && chartData1.length > 0"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: mapApiKey
          }"
          type="GeoChart"
          :data="chartData1"
          :options="chartOptions"
          :events="chartEvents"
          style
          ref="gChart"
          class="themap"
        />
        <div v-else class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <div slot="footer"></div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { GChart } from "vue-google-charts";
import Datepicker from "vuejs-datepicker";
import HeaderControl from "../../../components/shared/HeaderControl.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import router from "../../../router";
export default {
  props: ["state", "date_from", "date_to", "locations"],
  name: "MapByState",
  components: {
    GChart,
    router,
    Datepicker,
    LoadingCard,
    HeaderTitle,
    HeaderControl
  },
  data() {
    return {
      stateModal: false,
      mapReady: false,
      stateDateFrom: "",
      stateDateTo: "",
      loadingState: true,
      chartData: [],
      chartData1: [],
      mapApiKey: process.env.VUE_APP_GOOGLE_MAPS_API,
      chartOptions: {
        showZoomOut: true,
        tooltip: { isHtml: true },

        backgroundColor: "#3a4149",
        legend: {
          textStyle: { color: "black", fontSize: 16, font: "Segoe UI" }
        },
        region: "USA",
        sizeAxis: {
          minSize: 8, //code to set min and max marker size
          maxSize: 8
        },
        resolution: "provinces",
        magnifyingGlass: { enable: true, zoomFactor: 1.5 },
        displayMode: "markers",
        enableRegionInteractivity: true,
        keepAspectRatio: false,

        colorAxis: { colors: ["#28B463", "#6C3483"] }
      },
      chartEvents: {
        select: () => {
          const selection = this.$refs.gChart.chartObject;
          var selectedItem = selection.getSelection()[0];
          var topping = this.chartData[selectedItem.row + 1];
          var splitting = topping[2].split("#");
          var id = splitting[1];
          var city = topping[0];
          var lat = splitting[2];
          var lng = splitting[3];
          router.push(
            "/base/city/?loc=" +
              id +
              "&city=" +
              city +
              "&lat=" +
              lat +
              "&lng=" +
              lng
          );
        }
      }
    };
  },
  methods: {
    stateModalEvent() {
      if (this.fullscreenState) {
        this.toggleFullScreenState();
        this.stateModal = 1;
      } else {
        this.stateModal = 1;
      }
    },
    fetchCityReport() {
      this.loadingState = true;
      let params = {};
      params = {
        state: this.state,
        date_from: this.date_from,
        date_to: this.date_to
      };
      this.$http.get("api/arris/maps/mapByState.php", { params }).then(
        res => {
          this.loadingState = false;
          if (res.data && res.data.records) {
            this.chartData = res.data.records;
            var myFix = { type: "string", role: "tooltip", p: { html: true } };

            this.chartData[0][2] = myFix;

            var i;
            for (i = 1; i < this.chartData.length; i++) {
              var prvi = this.chartData[i][0].split("#");
              this.chartData[i][0] = prvi[0];
              this.chartData[i][2] =
                "<div style='width:130px'><span>Quantitiy: " +
                this.chartData[i][1] +
                "</span><br>" +
                "<span>$" +
                this.chartData[i][2].toFixed(2) +
                "</span><br></div><div style='display:none'>#" +
                prvi[1] +
                "#" +
                prvi[2] +
                "#" +
                prvi[3] +
                "#</div>";
            }
            this.loadingState = false;
            this.chartData1 = this.chartData;
          }
        },
        err => {
          console.log(err);
          this.loadingState = false;
        }
      );
    },
    toggleFullScreenLine() {
      this.$fullscreen.toggle(this.$el.querySelector(".lineClass"), {
        wrap: false,
        callback: this.fullscreenChangeLine
      });
    }
  },
  mounted() {
    this.chartOptions.region = "US-" + this.state;
    this.fetchCityReport();
  }
};
</script>

<style scoped>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.power {
  background-color: #f86c6b !important;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
